import type { ComponentProps, Ref } from 'react';
import type { HTMLAttributes } from 'react';
import { cx } from '../lib/cx';

export interface PanelProps extends HTMLAttributes<HTMLElement> {
  centered?: boolean;
}

export function Panel(
  { ref, centered = false, className, children, ...rest }: PanelProps & { ref?: Ref<HTMLElement> },
) {
  return (
    <section ref={ref} className={cx('panel', centered && 'is-centered', className)} {...rest}>
      {children}
    </section>
  );
}

export type PanelHeadProps = ComponentProps<'div'>;

export function PanelHead({ className, ...props }: PanelHeadProps) {
  return <div className={cx('panel-head', className)} {...props} />;
}
